import AddressFilter from './AddressFilter';
import BooleanFilter from './BooleanFilter';
import ClientFilter from './ClientFilter';
import ContactFilter from './ContactFilter';
import CouponCategoryFilter from './CouponCategoryFilter';
import CurrencyFilter from './CurrencyFilter';
import DateBetweenFilter from './DateBetweenFilter';
import DateFilter from './DateFilter';
import DateTimeBetweenFilter from './DateTimeBetweenFilter';
import DateTimeFilter from './DateTimeFilter';
import FulfilmentLocationFilter from './FulfilmentLocationFilter';
import NumberBetweenFilter from './NumberBetweenFilter';
import NumberFilter from './NumberFilter';
import OrderFilter from './OrderFilter';
import OrganisationFilter from './OrganisationFilter';
import PaymentMethodFilter from './PaymentMethodFilter';
import PaymentMethodCodeFilter from './PaymentMethodCodeFilter';
import PaymentProviderFilter from './PaymentProviderFilter';
import ShippingMethodFilter from './ShippingMethodFilter';
import SkuFilter from './SkuFilter';
import SpreadsheetFilter from './SpreadsheetFilter';
import SuggestionFilter from './SuggestionFilter';
import TextFilter from './TextFilter';
import UserFilter from './UserFilter';

export default {
  address: AddressFilter,
  boolean: BooleanFilter,
  client: ClientFilter,
  contact: ContactFilter,
  couponCategory: CouponCategoryFilter,
  currency: CurrencyFilter,
  dateBetween: DateBetweenFilter,
  date: DateFilter,
  dateTimeBetween: DateTimeBetweenFilter,
  datetime: DateTimeFilter,
  default: SuggestionFilter,
  fulfilmentLocation: FulfilmentLocationFilter,
  numberBetweenFilter: NumberBetweenFilter,
  number: NumberFilter,
  order: OrderFilter,
  organisation: OrganisationFilter,
  paymentMethod: PaymentMethodFilter,
  paymentMethodCode: PaymentMethodCodeFilter,
  paymentProvider: PaymentProviderFilter,
  search: TextFilter,
  shippingMethod: ShippingMethodFilter,
  sku: SkuFilter,
  spreadsheet: SpreadsheetFilter,
  suggestion: SuggestionFilter,
  text: TextFilter,
  user: UserFilter,
};
